module.exports = __webpack_public_path__ + "img/MobilyDisabeld.ea3044b8.svg";